<script setup lang="ts">
import { computed } from "vue";
import TextAreaField from "@/design/primitives/TextAreaField.vue";
import type { WidgetProps } from "./contract";

const props = defineProps<WidgetProps & { controlId?: string; describedBy?: string }>();
const emit = defineEmits<{ "update:modelValue": [unknown]; blur: [] }>();

const text = computed(() =>
	props.modelValue === null || props.modelValue === undefined ? "" : String(props.modelValue),
);
const rows = computed(() => Number(props.field.config.rows ?? 4));
</script>

<template>
	<TextAreaField
		:id="controlId"
		:model-value="text"
		:rows="rows"
		:disabled="disabled"
		:invalid="Boolean(error)"
		:described-by="describedBy"
		@update:model-value="emit('update:modelValue', $event)"
		@blur="emit('blur')"
	/>
</template>
